<template>

    <div class="user-menu">

        <b-navbar toggleable="lg" type="light">

            <b-navbar-brand to="/"><img src="/img/intervention_central-logo.png" alt="intervention central logo" /></b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-nav-item to="/admin"
                                v-if="isAdmin">
                        Admin
                    </b-nav-item>

                    <b-nav-item to="/docs"
                                v-if="userEmail != null">
                        My Documents
                    </b-nav-item>

                    <b-nav-item v-if="userEmail != null">
                        {{ userEmail }}
                    </b-nav-item>

                    <b-nav-item v-if="signedIn"
                                @click="signOut()">
                        Sign Out
                    </b-nav-item>

                    <b-nav-item v-if="!signedIn"
                                @click="showSignInModal()">
                        Sign In
                    </b-nav-item>

                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <!-- sign in modal -->

        <b-modal id="signin-modal" title="Sign In">

            <div v-if="!signInButtonClicked">
                <b-form-group label="Enter your email address:">
                    <b-form-input type="email"
                                  v-model="email">
                    </b-form-input>
                </b-form-group>

                <b-alert variant="info" show>
                    <p>You will be emailed a sign-in link.</p>
                    <p>This link is all you need to sign in - no password is required.</p>
                </b-alert>
            </div>

            <div v-if="signInButtonClicked">
                <b-alert variant="success" show>
                    <p>A sign-in link has been sent to your email.</p>
                    <p>Clicking the link in the email will open a new tab or window in your browser.</p>
                </b-alert>
            </div>

            <!-- modal footer -->
            <template v-slot:modal-footer>
                <div v-if="!signInButtonClicked">
                    <b-btn variant="primary" class="float-right"
                           :disabled="!emailIsValid"
                           @click="signIn()">
                        Sign In
                    </b-btn>
                </div>
                <div v-else>
                    <b-btn variant="primary" class="float-right"
                           @click="ok()">
                        OK
                    </b-btn>
                </div>
            </template>

        </b-modal>

    </div>

</template>

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: "UserMenu",
        data() {
            return {
                email: null,
                signInButtonClicked: false
            }
        },
        computed: {
            emailIsValid() {
                return this.email != null
            },
            userEmail() {
                return this.$store.state.currentUserEmail
            },
            signedIn() {
                return this.$store.state.currentUserEmail != null
            },
            isAdmin() {
                return this.$store.state.userIsAdmin
            }
        },
        methods: {
            showSignInModal() {
                this.signInButtonClicked = false
                this.$bvModal.show('signin-modal')
            },
            ok() {
                this.$bvModal.hide('signin-modal')
            },
            signIn() {
                this.signInButtonClicked = true
                this.$api.signIn(this.email)
            },
            signOut() {
                this.$api.signOut()
            },
        },
    })
</script>



<style lang="scss">

    @import 'sass/variables_mixins';

    @media (max-width:991px) {
        header {
            .navbar-collapse {
                background-color: $pink;
                max-width: 400px;
                height: 100%;
                position: fixed;
                z-index: 100;
                left: -300px;
                top: 0;

                .navbar-nav {
                    padding-top: 1em;

                    .nav-link {
                        color: #ffffff !important;
                        padding: .5em 1em;
                    }
                }

                &.show {
                    left: 0;
                }
            }
        }
    }

    @media (min-width:992px) {
        header .navbar-nav .nav-link {
            font-size: 14px;
        }
    }

    .navbar-light .navbar-toggler {
        border:none;
        &:focus {outline:none;}
    }

    .navbar-light .navbar-toggler-icon {
        background:url("../../public/img/hamburger-graphic.png") no-repeat left top;

    }

    .navbar-light .navbar-nav .nav-link {
        color:$link-color;
    }


</style>